import { Box, Text } from '@chakra-ui/react';

const Stat = ({ value, label }) => {
  return (
    <Box textAlign="center">
      <Text textStyle="bodyFamilyBold" fontSize="30px" color="white">
        {value}
      </Text>
      <Text textStyle="bodyFamilyMedium" color="white" textAlign="center">
        {label}
      </Text>
    </Box>
  );
};

export default Stat;
